<div class="catalog-container">
  <app-gradient class="gradient gradient__left"></app-gradient>
  <app-gradient class="gradient gradient__right"></app-gradient>
  <div class="catalog-container__header">
    <div class="catalog-container__header_content">
      <div class="catalog-container__header_data">
        <h1 class="heading-s">Catalogue</h1>
        <h3 class="body-m text-dark-alt">Select the products you want to display in the catalogue</h3>
      </div>
      <app-button [size]="'medium'" [type]="'primary'" [text]="'Add product'"></app-button>
    </div>
    <div class="catalog-container_search">
      <span class="body-m text-dark-alt">{{ totalRecords }} products in the catalogue</span>
      <div class="search-container">
        <mat-form-field appearance="fill">
          <mat-label>Search</mat-label>
          <mat-icon matSuffix>search</mat-icon>
          <input matInput placeholder="Search for a product" (keyup)="applyFilter($event)" />
        </mat-form-field>
      </div>
    </div>
    <table
      [dataSource]="dataSource"
      aria-label="This table displays the products"
      mat-table
      matSort class="product-table"
      multiTemplateDataRows>
      <ng-container matColumnDef="imageUrl">
        <th *matHeaderCellDef mat-header-cell class="col-small">
          &nbsp;
        </th>
        <td *matCellDef="let product" mat-cell class="col-small">
          <img class="catalog-image"
            [src]="product?.imageUrl"
            alt="catalogue"
            loading="lazy"
            (error)="onImageError($event)"/>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-header-cell mat-sort-header="name">
          Name
        </th>
        <td
          *matCellDef="let product"
          mat-cell>
          <div class="body-m text-brand cursor">
            {{ product.name }}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="price">
        <th *matHeaderCellDef mat-header-cell mat-sort-header="price">
          Price
        </th>
        <td
          *matCellDef="let product"
          mat-cell>
          <div class="body-m">
            {{ product.price | defaultCurrency: 'USD' }}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="lastUpdated">
        <th *matHeaderCellDef mat-header-cell mat-sort-header="lastUpdate">
          Last Update
        </th>
        <td
          *matCellDef="let product"
          mat-cell>
          <div class="body-m">
            {{ product.lastUpdated  | date : 'dd/MM/yyyy' }}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell>
          &nbsp;
        </th>
        <td *matCellDef="let product" class="body-m link-cell" mat-cell>
          <app-button
            type="tertiary" size="small" text="Remove">
          </app-button>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let element; columns: displayedColumns" mat-row></tr>
    </table>
    @if ((adminService.catalog()?.pagination?.totalPage ?? 0) > 1) {
      <app-pagination [currentPage]="currentPage" [totalPages]="adminService.catalog()?.pagination?.totalPage ?? 0" (pageChange)="onPageChange($event)"></app-pagination>

    }
  </div>
</div>